import React, { useState } from 'react';
import loadable from '@loadable/component';
import { TextLink } from '@vds/buttons';
import { resetNavigationTitle } from '../../common/MVAApiCall';
import { isMVA } from '../../common/Helpers';

const IPIModal = loadable(() => import('./IPIModal'));

// Important Plan Information Link 
const IPILink = () => {
  const [showFeaturesModal, setShowAddressModal] = useState(false);

  const planInfoModal = () => {
    setShowAddressModal(true);
  };

  const showToggleModal = (value) => {
    setShowAddressModal(value);
    if (!value) {
      resetNavigationTitle(isMVA());
    }
  };

  return (
    <>
      <TextLink
        onClick={() => planInfoModal()}
        data-track='{"type": "link","name": "important plan information","data":{"page":{"detail":"important plan information modal" }}}'
      >
        important plan information
      </TextLink>
      {showFeaturesModal && <IPIModal opened={showFeaturesModal} onOpenedChange={showToggleModal} />}
    </>
  );
};

export default React.memo(IPILink);
